import { type Values } from '@discover-use-router-state';
import { ByCategory } from './types';

export default function getValidTagIds(
  routerValues: Values,
  optionKeys: string[],
  optionsByKey: ByCategory<number[]>
): number[] {
  return optionKeys
    .map((key) => optionsByKey[key]?.filter((option) => routerValues[key].includes(`${option}`)))
    .flat()
    .filter((value): value is number => value !== undefined);
}
